import { render, staticRenderFns } from "./CateNav.vue?vue&type=template&id=3b61fd26&scoped=true"
import script from "./CateNav.vue?vue&type=script&lang=js"
export * from "./CateNav.vue?vue&type=script&lang=js"
import style0 from "./CateNav.vue?vue&type=style&index=0&id=3b61fd26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b61fd26",
  null
  
)

export default component.exports